import React from "react";
import Shell from "@/pages/Shell";
import AdminSidebar from "@/pages/admin/AdminSidebar";

/**
 * AdminShell — admin layout.
 *
 * Escritorio (lg+): barra lateral agrupada (AdminSidebar) + contenido.
 * Móvil/tablet (<lg): manda MobileBottomNav, que ya pinta Shell.
 *
 * Ya no se le pasan `tabs` a Shell. La tira horizontal de pestañas vivía
 * dentro de una cabecera `hidden lg:block` y se ocultaba a sí misma con
 * `tabsHiddenOnLg`, así que no se veía en ningún tamaño de pantalla: pintaba
 * 28 enlaces que nadie podía pulsar. La navegación del admin son la barra
 * lateral y la barra inferior, y ahora también en el código.
 */
export default function AdminShell({ children }) {
  return (
    <Shell>
      <div className="lg:flex lg:gap-8">
        <AdminSidebar />
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </Shell>
  );
}
